<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="(e) => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <ChangeLogCollapse
            class="mt-2"
            v-if="(visibleChangeLog && !has({ menuContext, key: 'hideChangeLog', value: 'true' })) && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
import { Card, Form } from "ant-design-vue";
import lodash from "lodash";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../app.logic";
import { onCallChangeLog } from "../../../../utils/form";
import { matchMenu, has } from "../../../../utils/menu-context";
import { callChanges, createFormTitle, createSearchOneCriteria, initForm, isLoading, onClickModalOk, state } from "./user-company.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../../components/change-log/ChangeLogCollapse")),
    },
    props: {
        menuContext: { default: () => matchMenu("/app/company/companies", stateApp.authInfo.menus) },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
    },
    setup(props) {
        const i18n = useI18n();
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        const callOnClickModalOk = () => onClickModalOk({ props, data, refs });
        const title = computed(() => createFormTitle({ props, data, refs }));
        const fieldLogs = computed(() => {
            return lodash.cloneDeep(data.fieldLogs).map((d) => {
                const oldLabel = d.label;
                if (d.key?.startsWith("refCompany.refFactoryAddrTh") || d.key === "refCompany.factoryTambonTh")
                    d.label = () => `${i18n.t("model.company.refFactoryAddrTh")} ${oldLabel?.()}`;
                if (d.key?.startsWith("refCompany.refFactoryAddrEn") || d.key === "refCompany.factoryTambonEn")
                    d.label = () => `${i18n.t("model.company.refFactoryAddrEn")} ${oldLabel?.()}`;
                if (d.key?.startsWith("refCompany.refOfficeAddrTh") || d.key === "refCompany.officeTambonTh")
                    d.label = () => `${i18n.t("model.company.refOfficeAddrTh")} ${oldLabel?.()}`;
                if (d.key?.startsWith("refCompany.refOfficeAddrEn") || d.key === "refCompany.officeTambonEn")
                    d.label = () => `${i18n.t("model.company.refOfficeAddrEn")} ${oldLabel?.()}`;
                return d;
            });
        });
        return {
            props,
            data,
            refs,
            state,
            title,
            fieldLogs,
            isLoading,
            callChanges,
            callOnClickModalOk,
            createSearchOneCriteria,
            onCallChangeLog,
            has,
        };
    },
});
</script>
